import { connect } from 'react-redux'
import AppRoot from './AppRoot'
import { replace } from 'react-router-redux'
import { setAtTop } from 'components/Scroll/Scroll.actions'

const stateToProps = ({ auth, layout }) => ({
  layout,
  isLoggedIn: auth.token && auth.user.id,
})

const dispatchToProps = {
  replace,
  setAtTop,
}

export default connect(stateToProps, dispatchToProps)(AppRoot)



// WEBPACK FOOTER //
// ./src/pages/AppRoot/AppRoot.container.js